export default __webpack_public_path__ + "static/media/feather-users.1cb6892e.svg";